module.exports = __webpack_public_path__ + "img/star.19c3d63d.svg";